import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=7d8de6cd&scoped=true"
import script from "./GroupView.vue?vue&type=script&lang=ts"
export * from "./GroupView.vue?vue&type=script&lang=ts"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=7d8de6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8de6cd",
  null
  
)

export default component.exports